import I18nRegistry from './I18nRegistry';

export {
    I18nRegistry
};
